import AbstractPainting from './assets/abstract-painting.png';
import Calligraphy from './assets/calligraphy.png';
import ChessFundamentals from './assets/chess-fundamentals.png';
import CoffeePainting from './assets/coffee-painting.png';
import HandCraft from './assets/hand-craft.png';
import Mandala from './assets/mandala.png';
import PuzzleSolving from './assets/puzzle-solving.png';
import RubikCube from './assets/rubik-cube.png';

export const HOBBY_CLASS_IMAGES: Record<
  string,
  { image: string; alt: string; color: string; colorValue: string }
> = {
  'Rubik Cube': {
    image: RubikCube,
    alt: 'Rubik Cube',
    color: 'blue-chaos-light',
    colorValue: 'hsl(220.825 100% 81%)',
  },
  'Chess Fundamentals': {
    image: ChessFundamentals,
    alt: 'Chess Fundamentals',
    color: 'hot-sun-yellow-light',
    colorValue: 'hsl(42 95% 75%)',
  },
  'Puzzle Solving': {
    image: PuzzleSolving,
    alt: 'Puzzle Solving',
    color: 'underwater-fern-green',
    colorValue: 'hsl(164 92% 41%)',
  },
  'Coffee Painting': {
    image: CoffeePainting,
    alt: 'Coffee Painting',
    color: 'orange-persimmon-dark',
    colorValue: 'hsl(17 52% 58%)',
  },
  'Abstract Painting': {
    image: AbstractPainting,
    alt: 'Abstract Painting',
    color: 'pink-dream',
    colorValue: 'hsl(0 100% 62%)',
  },
  Calligraphy: {
    image: Calligraphy,
    alt: 'Calligraphy',
    color: 'nirvana-jewel',
    colorValue: 'hsl(184 29% 52%)',
  },
  Mandala: {
    image: Mandala,
    alt: 'Mandala',
    color: 'patrice-green-dark',
    colorValue: 'hsl(140 29% 55%)',
  },
  'Hand Craft': {
    image: HandCraft,
    alt: 'Hand Craft',
    color: 'hot-sun-light',
    colorValue: 'hsl(40.8 95% 74%)',
  },
};
